// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".safety-confirm-table-component .accepting-text[data-v-3c254efd],.safety-confirm-table-component .no-accepting-text[data-v-3c254efd]{width:72px}.safety-confirm-table-component .register-btn[data-v-3c254efd]{width:120px}.safety-confirm-table-component .delete-btn[data-v-3c254efd],.safety-confirm-table-component .detail-btn[data-v-3c254efd]{width:64px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
